var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "viewWrapper" },
    [
      _vm._l(_vm.formData, function (field, index) {
        return _c("div", { key: index, staticClass: "itemWrapper" }, [
          _c("span", { staticClass: "inputLabel" }, [
            _vm._v("\n\t\t\t" + _vm._s(field.inputLabel) + "\n\t\t"),
          ]),
          _vm._v(" "),
          _c("input", {
            staticClass: "inputField",
            attrs: { id: field.id, disabled: _vm.loading },
            domProps: { value: field.value },
            on: {
              input: function ($event) {
                field.value = $event.target.value
              },
            },
          }),
        ])
      }),
      _vm._v(" "),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "loadingBar",
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.loading,
              expression: "!loading",
            },
          ],
          staticClass: "actionbutton full",
          on: { click: _vm.save },
        },
        [
          _vm._v(
            "\n\t\t" +
              _vm._s(_vm.$t("dialogButtonProductAttributesOk")) +
              "\n\t"
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }